export default "__VITE_ASSET__tCBxWkyt__"